<template>
  <el-scrollbar class="side-bar-container" :class="{ 'is-collapse': collapse }">
    <vab-logo :collapse="collapse" />
    <el-menu
      :background-color="variables['menu-background']"
      :text-color="variables['menu-color']"
      :active-text-color="variables['menu-color-active']"
      :default-active="activeMenu"
      :collapse="collapse"
      :collapse-transition="false"
      :default-openeds="defaultOpens"
      :unique-opened="uniqueOpened"
      mode="vertical"
    >
      <template v-for="route in routes">
        <my-vab-side-bar-item
          :key="route.path"
          :full-path="route.path"
          :item="route"
        />
      </template>
    </el-menu>
  </el-scrollbar>
</template>
<script>
  import variables from '@/styles/variables.scss'
  import { mapGetters } from 'vuex'
  import { defaultOopeneds, uniqueOpened } from '@/config'
  import myVabSideBarItem from './components/VabSideBarItem.vue'

  export default {
    name: 'VabSideBar',
    data() {
      return {
        uniqueOpened,
      }
    },
    computed: {
      ...mapGetters({
        collapse: 'settings/collapse',
        routes: 'routes/routes',
      }),
      defaultOpens() {
        if (this.collapse) {
        }
        return defaultOopeneds
      },
      activeMenu() {
        const route = this.$route
        const { meta, path } = route
        if (meta.activeMenu) {
          return meta.activeMenu
        }
        return path
      },
      variables() {
        return variables
      },
    },
    components: {
      myVabSideBarItem
    }
  }
</script>
<style lang="scss" scoped>
  @mixin active {
    &:hover {
      color: $base-color-white;
      background-color: $base-menu-background-hover !important;
    }

    &.is-active {
      color: $base-color-white;
      background-color: $base-menu-background-active-hover !important;
    }
    &.is-active:hover {
      color: $base-color-white;
      background-color: $base-menu-background-active-hover !important;
    }
  }

  .side-bar-container {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    z-index: $base-z-index;
    width: $base-left-menu-width;
    height: 100vh;
    overflow: hidden;
    background: $base-menu-background;
    box-shadow: 2px 0 6px rgba(0, 21, 41, 0.35);
    transition: width $base-transition-time;

    &.is-collapse {
      width: $base-left-menu-width-min;
      border-right: 0;

      ::v-deep {
        .el-menu {
          transition: width $base-transition-time;
        }

        .el-menu--collapse {
          border-right: 0;
          width: $base-left-menu-width-min;
          li{
            text-align: center;
            i{
              margin-right: 0 !important;
              top: 0 !important
            }
          }
          .el-submenu__icon-arrow {
            right: 10px;
            margin-top: -3px;
          }
        }
      }
    }

    ::v-deep {
      .el-scrollbar__view{
        height: 100%;
      }
      .el-scrollbar__wrap {
        overflow-x: hidden;
      }

      .el-menu {
        border: 0;
        min-height: calc(100% - 60px);
        border-right: 1px solid rgba(204,204,204,.5);
        .vab-fas-icon {
          padding-right: 3px;
          font-size: $base-font-size-default;
        }

        .vab-remix-icon {
          padding-right: 3px;
          font-size: $base-font-size-default + 2;
        }
      }
      .el-menu--inline {
        border: 0;
      }

      .el-menu-item,
      .el-submenu__title {
        height: $base-menu-item-height;
        overflow: hidden;
        line-height: $base-menu-item-height;
        text-overflow: ellipsis;
        white-space: nowrap;
        vertical-align: middle;
      }

      .el-menu-item {
        @include active;
        i{
          color: #666;
        }
      }

      .el-submenu.is-active .el-submenu__title {
        color: $base-menu-color-active !important;

        .iconfont {
          color: $base-menu-color-active !important;
        }
        .el-icon-arrow-down {
          color: $base-menu-color-active !important;
        }
      }

      .el-submenu:hover{
        background: $base-menu-background-hover !important;
      }
      .el-submenu__title:hover {
        background: rgba(0,0,0,0) !important;
      }
      .el-menu-item.is-active i{
        color: $base-menu-color-active;
      }
      .el-menu--vertical{
        .el-menu{
          width: 166px;
          min-width: 166px;
          padding: 0;
        }
        .el-menu-item{
          width: 166px;
          min-width: 166px;
          margin: 0 !important;
          padding: 0 !important;
          text-align: center;
        }
      }
    }
  }
</style>
